// The one navigation a sign-out makes, and the flag that tells every other redirect to stand
// down while it runs (BUG-2233). In the phone app a cancelled main-frame load shows the bundled
// "Can't reach Auctogon" page, so a second navigation started during sign-out must never run.

const SIGN_IN_PATH = '/auth/sign-in';

let underway = false;
let restoreGuardInstalled = false;

/**
 * Whether a sign-out is under way. Redirects that would otherwise send the operator to sign-in
 * (AuthGuard, the 401 handler) check it and do nothing.
 *
 * @returns true once {@link markSignOutUnderway} or {@link startSignOutNavigation} has run.
 */
export function isSignOutNavigationUnderway(): boolean {
  return underway;
}

/**
 * Mark the sign-out as under way. Called the moment the server confirms the revoke, before the
 * awaited cleanup, so a 401 from a call still in flight (the cookie is already gone) cannot start
 * a second navigation in that window.
 */
export function markSignOutUnderway(): void {
  underway = true;
}

/**
 * Load the sign-in page as a full document. A full load, not a router call: it drops every
 * in-memory client state of the signed-out session.
 *
 * @sideEffect Navigates the page to sign-in; later redirects to sign-in stand down. Once, installs
 *   a `pageshow` listener: a back-forward-cache restore of this page brings its heap (with the
 *   flag set and the session state cleared) back without re-running any effect, so it reloads.
 */
export function startSignOutNavigation(): void {
  markSignOutUnderway();
  if (!restoreGuardInstalled) {
    restoreGuardInstalled = true;
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) window.location.reload();
    });
  }
  window.location.assign(SIGN_IN_PATH);
}

/** Test seam: forget a sign-out so the next test starts signed in. */
export function __resetSignOutNavigationForTest(): void {
  underway = false;
}
